const uuid = require("uuid");

export default {
  methods: {
    uuid() {
      return uuid.v4();
    },
  },
};
